// EmojiPicker Component
// Based on documentation from docs/03_CHAT_MESSAGING_SYSTEM.md

import React, { useState } from 'react';
import { EMOJI_LIST } from '../utils/constants';
import { searchEmojisByKeyword } from '../utils/emojiData';
import '../styles/EmojiPicker.css';

const EmojiPicker = ({ onEmojiSelect, show, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = {
    all: 'All',
    smileys: 'Smileys & People',
    gestures: 'Gestures',
    hearts: 'Hearts & Love',
    nature: 'Nature',
    objects: 'Objects',
    symbols: 'Symbols'
  };

  const categorizedEmojis = {
    smileys: EMOJI_LIST.slice(0, 50),
    gestures: EMOJI_LIST.slice(50, 100),
    hearts: EMOJI_LIST.slice(100, 150),
    nature: EMOJI_LIST.slice(150, 180),
    objects: EMOJI_LIST.slice(180, 210),
    symbols: EMOJI_LIST.slice(210, 230)
  };

  const getFilteredEmojis = () => {
    if (searchTerm) {
      // When searching, return all matching emojis from keyword database
      let searchResults = searchEmojisByKeyword(searchTerm);
      // If a specific category is selected, filter results to that category
      if (activeCategory !== 'all') {
        const categoryEmojis = categorizedEmojis[activeCategory] || [];
        searchResults = searchResults.filter(emoji => categoryEmojis.includes(emoji));
      }
      return searchResults;
    }
    
    return activeCategory === 'all' ? EMOJI_LIST : categorizedEmojis[activeCategory] || [];
  };

  const handleEmojiClick = (emoji) => {
    onEmojiSelect(emoji);
    // Do NOT close picker or clear search — allow multiple selections
  };

  if (!show) return null;

  return (
    <div className="emoji-picker-overlay" onClick={onClose}>
      <div className="emoji-picker" onClick={(e) => e.stopPropagation()}>
        <div className="emoji-picker-header">
          <input
            type="text"
            className="emoji-search"
            placeholder="Search emojis..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="emoji-close" onClick={onClose}>&times;</button>
        </div>

        <div className="emoji-categories">
          {Object.entries(categories).map(([key, label]) => (
            <button
              key={key}
              className={`emoji-category ${activeCategory === key ? 'active' : ''}`}
              onClick={() => setActiveCategory(key)}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="emoji-list">
          {getFilteredEmojis().map((emoji, index) => (
            <button
              key={index}
              className="emoji-item"
              onClick={() => handleEmojiClick(emoji)}
              title={emoji}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmojiPicker;
